import axios from "@/plugins/axios";
import credentials from "./credentials";

let url = "/api/coturn";

export const coturn = {
    credentials,
};

export default coturn;
